
































































































































































import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import NotificationBarComponent from "@/components/pages/notifications/NotificationBarComponent.vue";
import SelectComponent from "@/components/common/parts/SelectComponent.vue";
import InputTextComponent from "@/components/common/parts/InputTextComponent.vue";
import { GetNoticeResponse } from "@/typescript/api_client/emesh_api/notifications/types";
import DisplayFilterMenuComponent from "@/components/pages/dashboard/DisplayFilterMenuComponent.vue";
import { getRegionApi } from "@/typescript/api_client/emesh_api/master/region_api";
import { getPrefectureApi } from "@/typescript/api_client/emesh_api/master/prefecture_api";
import { getCompanyApi } from "@/typescript/api_client/emesh_api/master/company_api";
import { getStoregroupApi } from "@/typescript/api_client/emesh_api/stores/storegroup_api";
import { getNoticeApi } from "@/typescript/api_client/emesh_api/notifications/notice_api";
import { DisplayFilterMenu } from "@/typescript/pages/dashboard/index.ts";
import { Moment } from "../../../typescript/lib/common/moment";
import { getStatusImg } from "@/typescript/pages/dashboard/functions";
import {
  GetRegionResponse,
  GetPrefectureResponse,
  GetCompanyResponse
} from "@/typescript/api_client/emesh_api/master/types";
import {
  GetStoregroupResponse,
  GetStoreListResponse,
  Store
} from "@/typescript/api_client/emesh_api/stores/types";
import {
  StatusList,
  Status,
  SelectedRegion,
  SelectedPrefecture,
  SelectedCompany,
  SelectedStoregroup,
  SelectedStore
} from "@/typescript/pages/dashboard/types";
export {
  DisplayFilterMenu,
  GetNoticeResponse,
  GetRegionResponse,
  GetPrefectureResponse,
  GetCompanyResponse,
  GetStoregroupResponse,
  GetStoreListResponse,
  Store,
  Status,
  StatusList,
  SelectedRegion,
  SelectedPrefecture,
  SelectedCompany,
  SelectedStoregroup,
  SelectedStore
};

const format: string = "YYYY/MM/DD HH:mm:ss";

@Component({
  components: {
    DisplayFilterMenuComponent,
    NotificationBarComponent,
    SelectComponent,
    InputTextComponent
  }
})
export default class DashboardHeaderComponent extends Vue {
  isFilter: boolean = true;
  latestNotification: GetNoticeResponse | false = false;
  selectWidth: string = "200px";
  inputWidth: string = "200px";
  regions: GetRegionResponse[] = [];
  prefectures: GetPrefectureResponse[] = [];
  companies: GetCompanyResponse[] = [];
  storegroups: GetStoregroupResponse[] = [];
  storeList: GetStoreListResponse | {} = {};
  pageNo: number = 1;
  pageCount: number = 10;
  statusList: StatusList = {
    0: { name: "未接続", value: 0 },
    1: { name: "閉店", value: 1 },
    2: { name: "稼働中", value: 2 },
    3: { name: "警報", value: 3 },
    all: { name: "全て", value: "all" }
  };
  selectedStatus: Status = this.statusList["all"];

  @Prop()
  searchValue!: string;

  @Prop()
  inputStoreNo!: string;

  @Prop()
  stores!: Store[];

  @Emit()
  changeRegion(region: SelectedRegion) {
    return region;
  }

  @Emit()
  changePrefecture(prefecture: SelectedPrefecture) {
    return prefecture;
  }

  @Emit()
  changeCompany(company: SelectedCompany) {
    return company;
  }

  @Emit()
  changeStoregroup(storegroup: SelectedStoregroup) {
    return storegroup;
  }

  @Emit()
  changeStoreName(store: SelectedStore) {
    return store;
  }

  @Emit()
  changeStatus(status: Status) {
    this.setValue("selectedStatus", status);
    return status;
  }

  @Emit()
  enterSearchValue(event: KeyboardEvent) {
    const inputEvent = event.target as HTMLInputElement;
    return inputEvent.value;
  }

  @Emit()
  enterStoreNo(value: string): string {
    return value;
  }

  @Emit()
  changeInputStoreNo(value: string): string {
    return value;
  }

  get internalSearchValue(): string {
    return this.searchValue;
  }

  set internalSearchValue(value: string) {
    this.searchValue = value;
  }

  get statusImg(): string {
    return getStatusImg(this.selectedStatus.value);
  }

  displayNotification() {
    getNoticeApi(1)
      .then((resp: GetNoticeResponse[]) => {
        const notification = resp.map(notice => {
          notice.created_datetime = Moment.convertApiDateTime(
            notice.created_datetime,
            "YYYY/MM/DD HH:mm"
          );
          return notice;
        })[0];
        this.latestNotification = notification;
      })
      .catch(() => {
        this.latestNotification = false;
      });
  }

  setRegions() {
    getRegionApi().then((resp: GetRegionResponse[]) => {
      this.regions = resp;
    });
  }

  setPrefectures() {
    getPrefectureApi().then((resp: GetPrefectureResponse[]) => {
      this.prefectures = resp;
    });
  }

  setCompanies() {
    getCompanyApi().then((resp: GetCompanyResponse[]) => {
      this.companies = resp;
    });
  }

  setStoregroups() {
    getStoregroupApi().then((resp: GetStoregroupResponse[]) => {
      this.storegroups = resp;
    });
  }

  setValue(key: string, value: any) {
    this[key] = value;
  }

  created() {
    this.displayNotification();
    this.setRegions();
    this.setPrefectures();
    this.setCompanies();
    this.setStoregroups();
  }

  // (お知らせ作成日 + 一週間) > API 実行時間 なら、true
  isWithinAWeek(): boolean {
    if (!this.latestNotification) return false;

    const notificationExpirationDate: string = new Moment(
      format,
      this.latestNotification.created_datetime,
      format
    ).addDate(7, "d");
    const now = new Moment(format).getFormatDate();

    return Moment.isBefore(now, notificationExpirationDate);
  }
}
